import React from 'react'
import nouislider from 'nouislider'

export default class Slider extends React.Component {
  componentDidMount() {
    const { start, stop, min, max, updateStart, updateStop } = this.props
    this.slider = nouislider.create(this.range, {
      start: [start, stop],
      range: { min: [min], max: [max] },
      connect: true,
      step: 1,
      tooltips: [{ to: val => `Age ${parseInt(val, 10)}` }, { to: val => `Age ${parseInt(val, 10)}` }],
      margin: 1
    })
    
    let oldStart, oldStop
    this.slider.on('start', () => {
      [oldStart, oldStop] = this.slider.get().map(val => Number(val))
    })
    this.slider.on('end', () => {
      const [newStart, newStop] = this.slider.get().map(val => Number(val))
      if (newStart !== oldStart) updateStart(newStart)
      if (newStop !== oldStop) updateStop(newStop)
    })
  }

  componentWillReceiveProps(nextProps) {
    const { start, stop, min, max, updateStart, updateStop } = nextProps
    if (max < stop) updateStop(max)
    if (min > start) updateStart(min)
    this.slider.updateOptions({
      start: [start, stop],
      range: { min: [min], max: [max] }
    })
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    const { label } = this.props
    return (
      <div className="slider">
        { label && <label>{label}</label> }
        <div className="slider__range">
          <div ref={node => this.range = node} />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/Slider.js